import React from 'react';
import './DisplayPrinter.css'
import ExternalLink from '../../../../../assets/images/hardware-inclusive/external-link.svg';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { getLangCode } from '../../../../../utils/Internationalization/handleAppInternationalization';
import { generateDeviceURL } from '../../../../../utils/HardwareInclusive/HardwareInclusive';
import { PRINTER_TYPE_API_MAP } from '../../../../../constants/AppConstants';

const DisplayPrinter = (props) => {
    const { printerModel, printerImage, cName, defaultPrinterImage, printerTypeId } = props
    const printerByFeaturesResult = useSelector((state) => state.GetHWPrinterByFeatures)
    const languageCode = getLangCode()
    const { t } = useTranslation(['translation'])
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <button type="button" className="slick-prev">Previous</button>,
        nextArrow: <button type="button" className="slick-next">Next</button>
    };

    const onViewMoreDetails = () => {
        const modelDetailsURL = generateDeviceURL(languageCode, PRINTER_TYPE_API_MAP[printerTypeId], printerModel)
        window.open(modelDetailsURL, "_blank", "noopener,noreferrer")
    }
    return (
        <div className={`customize-printer-image-wrapper1 ${cName === "flex-column" ? "flex-column" : "flex-row"}`}>
            {printerByFeaturesResult?.loading ?
                <>
                    <div className="circular-skeleton-flex">
                        <Skeleton
                            circle
                            className="circular-skeleton"
                            height="108px"
                            width="108px"
                            duration={0.9}
                        />
                    </div>
                    <div className='pi-device-model'>
                        <Skeleton height="16px" width="180px" duration={0.9} />
                    </div>
                </>
                :
                <>
                    <div className='cp-printer-img-wrapper'>
                        {cName === "flex-row"
                            ?
                            <img src={printerImage ? printerImage[0] : defaultPrinterImage} alt={`Printer`} />
                            :
                            printerImage && printerImage.length > 1 ? (
                                <div className="slider-container">
                                    <Slider key={`${printerModel}-${printerImage?.length}`} {...settings}>
                                        {printerImage.map((image, index) => (
                                            <div key={index}>
                                                <img src={image} alt={`Printer ${index + 1}`} />
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            ) : (
                                <div className="single-image-wrapper">
                                    <img
                                        src={printerImage?.[0] || defaultPrinterImage}
                                        alt="Printer"
                                    />
                                </div>
                            )
                        }
                    </div>
                    {printerModel ?
                        <div className='pi-device-model-wrapper'>
                            <div className='pi-device-model'>
                                <div>{t("MY_DEVICES.DEVICE_DETAILS.MODEL")}</div>
                                <div>{printerModel}</div>
                            </div>
                            <button className='pi-view-model-details' onClick={() => onViewMoreDetails()}>
                                {t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DISPLAY_IMAGE.VIEW_MODEL_DETAILS")}
                                <img src={ExternalLink} alt="view more details" />
                            </button>
                        </div>
                        :
                        <div className='representativ-img-text'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DISPLAY_IMAGE.REPRESENTATIVE_IMAGE")}</div>
                    }
                </>}
        </div>
    );
};

export default DisplayPrinter;